goog.provide('el8.ptdata.unreadLetterNotifications');

goog.require('el8.service.urls');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.letter');
goog.require('el8.data.currUser');
goog.require('el8.data.referencedUsers');
goog.require('el8.template.ptdata.letters');
goog.require('el8.service.tz');

el8.ptdata.unreadLetterNotifications = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();
    
    _class.addIntProperty('letterId');

    _class.addStringProperty('actionTaken');
    _class.addDateTime('unreadAlertDate');
    _class.addIntProperty('unreadAlertInDays');
    _class.addIntProperty('newUnreadAlertInDays');
    _class.addDateTime('newUnreadAlertDate');
    

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

	_class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);
        // load these letter into the letter cache and store just the ids in the notification
        if (spec.letter) {
            el8.ptdata.letters.create(spec.letter);
            this.setLetterId(spec.letter.id);
        }
    };
    
    _class.prototype.resend = function(opts) {
        opts = opts || {};
        var letter = this.getLetter();
        opts['resendEmail'] = true;
        letter.refaxLetter(opts);
    };
    
    
    _class.prototype.acknowledgeAndSignOff = function(opts) {
        opts = opts || {};

        var data = {'signOff': true };
        
        $.el8_ajax({
            url: el8.service.urls.get('updateUnreadLetterNotification', [this]),
            type: 'POST',
            data: JSON.stringify(data),
            success: function(data) {
                var updatedNotification = el8.ptdata.unreadLetterNotifications.create(data);
                if (opts.successCb) { opts.successCb(updatedNotification); }
            }
        });
    };
    
    _class.prototype.remindAgainLater = function(opts) {
        opts = opts || {};
    
        var data = {};
        if (opts.remindAgainInDays) {
            data.days = opts.remindAgainInDays;
            var signed_unread_alert_date = el8.service.tz.today().addDays(opts.remindAgainInDays*1);
            data.signed_unread_alert_date = el8.service.tz.asServerFormatDate(signed_unread_alert_date);
        }
    
        $.el8_ajax({
            url: el8.service.urls.get('updateUnreadLetterNotification', [this]),
            type: 'POST',
            data: JSON.stringify(data),
            success: function(data) {
                var updatedNotification = el8.ptdata.unreadLetterNotifications.create(data);
                if (opts.successCb) { opts.successCb(updatedNotification); }
            }
        });
    };

    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.letters.noteSummary(this.getLetter().asSoyMap()).el8_unescape();
    };
    
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        
        delete mapped['letterId'];
        mapped['letter'] = this.getLetter().asSoyMap();
        
        
        delete mapped['signUserBehalfId'];
        mapped['signUserBehalfName'] = this.getSignUserBehalfName();

        delete mapped['signUserId'];
        mapped['signUserName'] = this.getSignUserName();
        mapped['signUserType'] = this.getSignUserType();
        return mapped;
    };
    
    _class.prototype.getLetter = function() {
        return el8.ptdata.fetch({ patientId: this.getPatientId(), fetchId:this.getLetterId() });
    };
    
    
    return that;

})();
